import { render } from "./ShareHolderProfitLoss.vue?vue&type=template&id=3aef88de"
import script from "./ShareHolderProfitLoss.vue?vue&type=script&lang=js"
export * from "./ShareHolderProfitLoss.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__